<template>
  <div class="app-footer">
    <p>&copy; {{ new Date().getFullYear() }} Sloan Interactive, LLC.</p>
  </div>
</template>

<script>
  export default {
    name: "AppFooter",
  };
</script>

<style lang="scss">
  .app-footer {
    background: #eee;
    color: #bbb;
    font-size: 12px;
    font-weight: $font-semibold;
    padding: 12px $gutter;
    text-align: center;

    p:last-child {
      margin: 0;
    }
  }
</style>
